import styled from "styled-components";

const TableContainer = styled.div`
  width: 100%;
  max-width: 578px;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;

const CellItem = styled.div`
  display: flex;
  margin-bottom: 6px;
`;

const SuggestionText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FailureText = styled.p`
  font-size: 14px;
  line-height: 0.25em;
  font-weight: 700;
  color: ${(props) => props.color};
`;

const EmbeddedTableContainer = styled(TableContainer)`
  padding: 2px 4px 8px 4px;
`;

export {
  TableContainer,
  ButtonGroup,
  CellItem,
  SuggestionText,
  FailureText,
  EmbeddedTableContainer,
};
